import { render, staticRenderFns } from "./IlifestyleApp.vue?vue&type=template&id=47136c40&"
import script from "./IlifestyleApp.vue?vue&type=script&lang=js&"
export * from "./IlifestyleApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports